import {virtualDepartDriverNetwork} from "../network/VirtualDepartDriverNetwork";
import {virtualDepartStoreNetwork} from "../network/VirtualDepartStoreNetwork";
import {
    VIRTUAL_DEPART_DRIVER,
    VIRTUAL_DEPART_DRIVER_ERROR, VIRTUAL_DEPART_DRIVER_ERROR_MSG, VIRTUAL_DEPART_DRIVER_RESET,
    VIRTUAL_DEPART_DRIVER_SUCCESS, VIRTUAL_DEPART_STORE, VIRTUAL_DEPART_STORE_ERROR, VIRTUAL_DEPART_STORE_SUCCESS
} from "../constants/VirtualDepartDriverConstants";
import {virtualDepartDriverInitialState} from "../context/VirtualDepartDriverContext";


export const VirtualDepartDriverReducer = (state, action) => {
    console.log("VirtualDepartDriverReducer", state, action);
    switch (action.type) {
        case VIRTUAL_DEPART_DRIVER:
            const driverDispatcher = action.data.dispatcher;
            const driverId = action.data.driverId;
            virtualDepartDriverNetwork(driverId, driverDispatcher);
            return {...state, isLoading: true, requestCompleted: false};
        case VIRTUAL_DEPART_STORE:
            const storeDispatcher = action.data.dispatcher;
            const storeId = action.data.storeId;
            virtualDepartStoreNetwork(storeId, storeDispatcher);
            return {...state, isLoading: true, requestCompleted: false};
        case VIRTUAL_DEPART_DRIVER_SUCCESS:
            return {...state,
                isLoading: false,
                requestCompleted: true,
                message: action.data.message,
                type: action.data.alertType};
        case VIRTUAL_DEPART_DRIVER_ERROR:
            return {...state,
                isLoading: false,
                requestCompleted: true,
                message: action.data.message ? action.data.message : VIRTUAL_DEPART_DRIVER_ERROR_MSG,
                type: action.data.alertType};
        case VIRTUAL_DEPART_STORE_SUCCESS:
            return {...state,
                isLoading: false,
                requestCompleted: true,
                message: action.data.message,
                type: action.data.alertType};
        case VIRTUAL_DEPART_STORE_ERROR:
            return {...state,
                isLoading: false,
                requestCompleted: true,
                message: action.data.message ? action.data.message : VIRTUAL_DEPART_DRIVER_ERROR_MSG,
                type: action.data.alertType};
        case VIRTUAL_DEPART_DRIVER_RESET:
            return {...virtualDepartDriverInitialState};
        default:
            return state
    }
};


// WEBPACK FOOTER //
// ./src/components/virtualDepartDriver/reducer/VirtualDepartDriverReducer.js